import React from 'react';
import { Link } from 'react-router-dom';
import './style.css';
import share from './images/share.svg';

const NeddieButton: React.FC<{
  onClick?: any; //click event
  onChange?: any; //keystroke event
  type: 'anchor' | 'link' | 'button' | 'disabled' | 'share'; //anchor: link away from NEDDIE | link: navigate within NEDDIE | button: button to for click events | disabled: a disabled button | share: this type is reserved for sharingOptions component
  src?: any; //where the link or anchor will navigate
  value: any; //text that appears on the button
  isLight?: boolean; //true for white button
  isSquare?: boolean; //true for 1px radius edge
  isRound?: boolean; //true for 50px radius edge
  className?: string; //add your own class names if necessary
  openInNewTab?: boolean; //do you want this to open in a new tab?
}> = ({
  src,
  value,
  isLight,
  type,
  onClick,
  onChange,
  className,
  isSquare,
  isRound,
  openInNewTab
}) => {
    if (type === 'link') {
      return (
        <Link
          className='button-link'
          to={!src ? '/404' : src}
          target={openInNewTab ? '_blank' : ''}
        >
          <button
            className={`neddie-button ${isLight ? 'neddie-light' : ''} ${className ? className : ''
              } ${isSquare && 'neddie-button-squared'}`}
            onClick={onClick}
            onChange={onChange}
          >
            {value}
          </button>
        </Link>
      );
    } else if (type === 'anchor') {
      return (
        <a
          className={`neddie-button ${isLight ? 'neddie-light' : ''} ${className ? className : ''
            } ${isSquare ? 'neddie-button-squared' : ''}`}
          href={src}
          target='_blank'
          rel='noopener noreferrer'
        >
          {value}
        </a>
      );
    } else if (type === 'disabled') {
      return (
        <button
          disabled
          className={`neddie-button-disabled ${className ? className : ''} ${isSquare && 'neddie-button-squared'
            }`}
        >
          {value}
        </button>
      );
    } else if (type === 'share') {
      return (
        <button className={`neddie-button neddie-share-button ${isLight ? 'neddie-light neddie-share-button-light' : ''} ${className ? className : ''} ${isSquare && 'neddie-button-squared'}`}
          onClick={onClick} onChange={onChange}>
          {value} <img src={share}></img>
        </button>
      );
    } else {
      // TODO(known bug, left as-is intentionally): none of the <button>s in this
      // component set an explicit HTML `type`. Per spec a <button> with no type
      // inside a <form> defaults to type="submit" — so a NeddieButton placed
      // inside any <form> WILL submit that form on click unless its own onClick
      // calls e.preventDefault() (most callers don't, since the `type` PROP here
      // is 'button'/'link'/etc., which reads as "this isn't a submit button" but
      // does NOT set the actual DOM attribute). Confirmed to cause a real bug:
      // the Cancel button in ImageDropperCropper.tsx silently submitted the
      // enclosing fundraiser form (see that file's own preventDefault fix).
      // Adding type="button" here would fix it at the root, but this component
      // is used in ~40 files across the app that were not exhaustively audited
      // for reliance on the current (buggy) submit-by-default behavior, so that
      // fix was reverted per explicit request rather than risk an unverified
      // regression. If you add a new NeddieButton inside a <form>, either call
      // e.preventDefault() in its onClick yourself, or fix this properly by
      // adding type="button" to every branch above AND auditing all existing
      // usages first.
      return (
        <button className={`neddie-button ${isRound ? 'neddie-button-round' : ''} ${isLight ? 'neddie-light' : ''} ${className ? className : ''} ${isSquare && 'neddie-button-squared'}`} onClick={onClick} onChange={onChange}>
          {value}
        </button>
      );
    }
  };

export default NeddieButton;
